// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* This is the ONLY ChakraProvider your app needs */}
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);